import { PROGRESS_STATES } from 'constants/enums'

const disabledStates = [
  PROGRESS_STATES.awardRegAssessment.id,
  PROGRESS_STATES.awardRegApproval.id,
  PROGRESS_STATES.awardSetup.id,
  PROGRESS_STATES.awardInProgress.id,
  PROGRESS_STATES.awardLeaderSignoff.id,
  PROGRESS_STATES.awardOfficeSignoff.id,
  PROGRESS_STATES.awardCeremony.id,
  PROGRESS_STATES.awardLevelComplete.id,
  PROGRESS_STATES.awardInactive.id
]

export default function({
  componentRegApproval = null,
  componentAwardSignoff = null,
  componentRegAssignment = null,
  componentAwardOfficeSignoff = null
}) {
  return {
    [PROGRESS_STATES.awardRegAssessment.id]: {
      id: PROGRESS_STATES.awardRegAssessment.id,
      label: 'Registration assessment',
      intlKey: 'states.registration_assessment',
      content: componentRegAssignment,
      disabledStates
    },
    [PROGRESS_STATES.awardRegApproval.id]: {
      id: PROGRESS_STATES.awardRegApproval.id,
      label: 'Registration approval',
      intlKey: 'states.registration_approval',
      content: componentRegApproval,
      disabledStates
    },
    [PROGRESS_STATES.awardSetup.id]: {
      id: PROGRESS_STATES.awardSetup.id,
      label: 'Setup',
      intlKey: 'states.setup',
      content: null,
      disabledStates: [
        PROGRESS_STATES.awardRegAssessment.id,
        PROGRESS_STATES.awardRegApproval.id,
        PROGRESS_STATES.awardLeaderSignoff.id,
        PROGRESS_STATES.awardOfficeSignoff.id,
        PROGRESS_STATES.awardCeremony.id,
        PROGRESS_STATES.awardLevelComplete.id,
        PROGRESS_STATES.awardInactive.id
      ]
    },
    [PROGRESS_STATES.awardInProgress.id]: {
      id: PROGRESS_STATES.awardInProgress.id,
      label: 'In progress',
      intlKey: 'states.in_progress',
      content: null,
      disabledStates: [
        PROGRESS_STATES.awardRegAssessment.id,
        PROGRESS_STATES.awardRegApproval.id,
        PROGRESS_STATES.awardSetup.id,
        PROGRESS_STATES.awardOfficeSignoff.id,
        PROGRESS_STATES.awardCeremony.id,
        PROGRESS_STATES.awardLevelComplete.id,
        PROGRESS_STATES.awardInactive.id
      ]
    },
    [PROGRESS_STATES.awardLeaderSignoff.id]: {
      id: PROGRESS_STATES.awardLeaderSignoff.id,
      label: 'Award Leader signoff',
      intlKey: 'states.award_leader_signoff',
      content: componentAwardSignoff,
      disabledStates
    },
    [PROGRESS_STATES.awardOfficeSignoff.id]: {
      id: PROGRESS_STATES.awardOfficeSignoff.id,
      label: 'Office sign-off',
      intlKey: 'states.office_sign_off',
      content: componentAwardOfficeSignoff,
      disabledStates
    },
    [PROGRESS_STATES.awardLevelComplete.id]: {
      id: PROGRESS_STATES.awardLevelComplete.id,
      label: 'Completed',
      intlKey: 'states.completed',
      content: null,
      disabledStates: [
        PROGRESS_STATES.awardRegAssessment.id,
        PROGRESS_STATES.awardRegApproval.id,
        PROGRESS_STATES.awardSetup.id,
        PROGRESS_STATES.awardInProgress.id,
        PROGRESS_STATES.awardLeaderSignoff.id,
        PROGRESS_STATES.awardInactive.id
      ]
    },
    [PROGRESS_STATES.awardCeremony.id]: {
      id: PROGRESS_STATES.awardCeremony.id,
      label: 'Ceremony',
      intlKey: 'states.ceremony',
      content: null,
      disabledStates: [
        PROGRESS_STATES.awardRegAssessment.id,
        PROGRESS_STATES.awardRegApproval.id,
        PROGRESS_STATES.awardSetup.id,
        PROGRESS_STATES.awardInProgress.id,
        PROGRESS_STATES.awardLeaderSignoff.id,
        PROGRESS_STATES.awardOfficeSignoff.id,
        PROGRESS_STATES.awardInactive.id
      ],
      isLast: true
    },
    [PROGRESS_STATES.awardInactive.id]: {
      id: PROGRESS_STATES.awardInactive.id,
      label: 'Inactive',
      intlKey: 'states.inactive',
      content: null,
      disabledStates: ['DISABLED'],
      hasSeparator: true
    }
  }
}
